import { gql } from '@apollo/client'
import {
  CORE_BILLING_PRODUCT_FIELDS,
  CORE_BILLING_PRODUCT_PRICE_FIELDS,
  CORE_BILLING_PRODUCT_TEXT_FIELDS,
  CORE_BILLING_PROVIDER_PRODUCT_TEXT_FIELDS,
} from './fragments'

export const GET_USER_PLAN_GRID_LIST = gql`
  ${CORE_BILLING_PRODUCT_FIELDS}
  ${CORE_BILLING_PRODUCT_PRICE_FIELDS}
  ${CORE_BILLING_PRODUCT_TEXT_FIELDS}
  ${CORE_BILLING_PROVIDER_PRODUCT_TEXT_FIELDS}
  query UserBillingPlanGridList(
    $page: String!
    $language: ProviderProductLanguage!
  ) {
    userBillingPlanGridList(
        where: { page: $page, deviceType: { in: [Desktop] }, language: $language }
    ) {
      userBillingPlanGrids {
        deviceType
        billingPlanGrid {
          page
          bestValueBillingProviderProductId
          billingProviderProducts {
            ...CoreBillingProviderProductFields
            billingProduct {
              ...CoreBillingProductFields
            }
            billingProviderProductPrices {
              ...CoreBillingProductPricingFields
            }
            billingProviderProductText(language: $language) {
              ...CoreBillingProductTextFields
            }
          }
        }
      }
    }
}
`

export const GET_PLANS = gql`
  ${CORE_BILLING_PRODUCT_FIELDS}
  ${CORE_BILLING_PRODUCT_PRICE_FIELDS}
  ${CORE_BILLING_PRODUCT_TEXT_FIELDS}
  ${CORE_BILLING_PROVIDER_PRODUCT_TEXT_FIELDS}
  query Plans(
        $page: String!
        $language: ProviderProductLanguage!
        $planGrid: Boolean
) {
    billingProviderProductList(
        planGrid: $planGrid,
        page: $page,
        billingProduct: { platform: { eq: Gaia } },
        billingProvider: { name: { eq: zuora } },
        deviceType: Desktop,
        language: $language
    ) {
        billingProviderProducts {
          ...CoreBillingProviderProductFields
          billingProduct {
            ...CoreBillingProductFields
          }
          billingProviderProductPrices {
            ...CoreBillingProductPricingFields
          }
          billingProviderProductText(language: $language) {
            ...CoreBillingProductTextFields
          }
        }
    }
}
`

export const GET_PLANS_BY_SKU = gql`
  ${CORE_BILLING_PRODUCT_FIELDS}
  ${CORE_BILLING_PRODUCT_PRICE_FIELDS}
  ${CORE_BILLING_PRODUCT_TEXT_FIELDS}
  ${CORE_BILLING_PROVIDER_PRODUCT_TEXT_FIELDS}
  query PlansBySku(
        $language: ProviderProductLanguage!
        $skus: [String]
        $priceReplacementType: SubscriptionPricingReplacementType = none
        $discountCode: String! = ""
        $includeDiscount: Boolean! = false
) {
    billingProviderProductList(
        billingProduct: { platform: { eq: Gaia } },
        billingProvider: { name: { eq: zuora } },
        where: {
            sku: { in: $skus }
            type: { in: [Recurring, Gift] }
        }
    ) {
        billingProviderProducts {
          ...CoreBillingProviderProductFields
          billingProduct {
            ...CoreBillingProductFields
          }
          billingProviderProductPrices(subscriptionPricingReplacementType: $priceReplacementType) {
            ...CoreBillingProductPricingFields
          }
          billingProviderProductText(language: $language, subscriptionPricingReplacementType: $priceReplacementType) {
            ...CoreBillingProductTextFields
          }
          discount(
            discountCode: $discountCode
            language: $language
            page: checkout
          ) @include(if: $includeDiscount) {
            eligible
            errorCode
            discountedPricing {
              trialSegmentPrice
              trialSegmentPriceDiscounted
              trialTermLength
              trialTermType
              recurringPrice1
              recurringPrice1Discounted
              recurringTermLength1
              recurringTermType1
              recurringPrice2
              recurringPrice2Discounted
              recurringTermLength2
              recurringTermType2
              currency
              currencySymbol
              trialSegmentPriceFormatted
              trialSegmentPricePerMonth
              trialSegmentPricePerMonthFormatted
              recurringPrice1Formatted
              recurringPrice1PerMonth
              recurringPrice1PerMonthFormatted
              recurringPrice2Formatted
              recurringPrice2PerMonth
              recurringPrice2PerMonthFormatted
            }
          }
        }
    }
}
`

export const GET_PLAN_ELIGIBILITY = gql`
  query PlanEligibility($sku: String!, $page: PlanEligibilityPage!) {
    billingProviderProductEligibility(sku: $sku, page: $page) {
      eligible
      failureType
      errorCode
    }
  }
`
